<template>
    <div class="selected-product">
        <product-image :image="productImage"></product-image>

        <span class="part-name">
            {{assembledPartName}}
        </span>

        <button type="button" class="btn btn-customize btn--secondary" v-if="desktopMode" @click="previousScreen()">
            {{resources.screens.fragrance.buttonChangeProduct}}
        </button>
    </div>
</template>

<script src="./selected-product.js"></script>
